import React from 'react'
import { useQuery } from '@tanstack/react-query'

const XDomainContext = React.createContext<string | null>(null)

export function XDomainContextProvider({ children }: React.PropsWithChildren<{}>) {
  const xDomainHeader = useQuery(
    ['x-domain'],
    async () => {
      const { headers } = await fetch(window.location.origin, { method: 'HEAD' })

      const xDomainHeader = headers.get('x-domain')

      return xDomainHeader
    },
    { refetchOnWindowFocus: false, cacheTime: 0, staleTime: 0 }
  )

  if (xDomainHeader.status === 'loading') {
    return null
  }

  if (xDomainHeader.status === 'error' || xDomainHeader.data === null) {
    console.error('failed to load x-domain header, something went terribly wrong.')
    return null
  }

  return <XDomainContext.Provider value={xDomainHeader.data}>{children}</XDomainContext.Provider>
}

export function useXDomain() {
  const context = React.useContext(XDomainContext)

  if (!context) {
    throw new Error(
      'No valid context value. ' +
        'This hook can only be used inside of the XDomainContextProvider with a valid value. ' +
        'Which means the context value is a non empty string'
    )
  }

  return context
}
